function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.127 6.33L8.042 7.94 6.43 12.025 4.82 7.94.735 6.33 4.82 4.717 6.43.633l1.612 4.085 4.085 1.611z",
  fill: "#60F3AB"
});
function SvgStarBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 13",
    fill: "none"
  }, props), _ref);
}
export default __webpack_public_path__ + "fonts/star-big-e1673557c7b7b49fca1eb9269deafe5e.svg";
export { SvgStarBig as ReactComponent };